import CryptoJS from 'crypto-js'

const SDK_IV_LENGTH = 32
const SDK_KEY_LENGTH = 16

/**
 *  截断字符串最后的几位
 * @param str
 * @param lastLength  截断长度
 * @returns
 */
const truncateLastString = (str, lastLength = str?.length || 0) => str?.substring(str.length - lastLength, str.length)

export const sendMessageToClient = (event, data, route) => {
  window.parent.postMessage(
    {
      event,
      data: encryptData(
        JSON.stringify(data),
        truncateLastString(route.params.id, SDK_KEY_LENGTH),
        truncateLastString(route.params.id, SDK_IV_LENGTH)
      )
    },
    '*'
  )
}

export const getFormatMessage = (messageData, route) => {
  if (!messageData.data || !messageData.data.data || !messageData.data.event) return {}
  const event = messageData.data.event
  const data = messageData.data.data
  const jsonData = decryptData(
    data,
    truncateLastString(route.params.id, SDK_KEY_LENGTH),
    truncateLastString(route.params.id, SDK_IV_LENGTH)
  )
  const json = jsonData ? (typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData) : {}
  // 检查危险属性值
  const dangerousString = ['<script>', 'javascript:', 'onw+s*=', 'data:s*text/html']
  for (const str of dangerousString) {
    if (JSON.stringify(json).includes(str)) {
      throw new Error('There are dangerous information in the Card Options')
    }
  }
  return {
    event,
    data: json
  }
}

/**
 * 取id后32位
 * AES解密
 * @param {string} data - 待解密数据
 * @param {string} key - 加密密钥
 * @returns {string} 解密结果
 */
const decryptData = (data, key, iv) => {
  const bytes = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(iv)
  })
  return bytes.toString(CryptoJS.enc.Utf8)
}

/**
 * AES加密
 * @param {string} data - 待加密数据
 * @param {string} key - 加密密钥
 * @param {string} iv - 初始化向量
 * @returns {string} 加密结果
 */
export const encryptData = (data, key, iv) => {
  const bytes = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(iv)
  })
  return bytes.toString()
}
